import {Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {UtilsService} from '../../../../core/utils/utils.service';
import {ToastService} from "../../../../core/services/technique/toast.service";
import {
  PreparationConditionnementService
} from "../../../../core/services/conditionnements/preparation-conditionnement.service";
import {Subscription} from "rxjs";
import {ProductionService} from "../../../../core/services/gestion-production/production.service";
import * as moment from "moment/moment";
import {DxListComponent} from "devextreme-angular";
import BonConditionnementSettingsMl from "../../../../core/dtos/conditionnement/bon-conditionnement-settings-ml";

@Component({
  selector: 'yo-print-settings-editions-conditionnement',
  templateUrl: './print-settings-editions-conditionnement.component.html',
  styleUrls: ['./print-settings-editions-conditionnement.component.scss']
})
export class PrintSettingsEditionsConditionnementComponent implements OnInit, OnDestroy {

  constructor(public utils: UtilsService,
              private toastSvc: ToastService,
              private preparationConditionnementSvc: PreparationConditionnementService,
              private prodSvc: ProductionService) {
  }

  readonly PAYSAGE: string = 'PAYSAGE';
  readonly PORTRAIT: string = 'PORTRAIT';
  private subDisplayDialog: Subscription;

  typesJours: any[] =
    [
      {text: 'Jour de consommation', value: 'jourConso'},
      {text: 'Jour de conditionnement', value: 'jourCondi'},
    ];

  datesConso: any;
  datesCondi: any;
  selectedDates: any[];
  typeJourSelected: any;
  @ViewChild("productList") listPlats: DxListComponent;
  @Input('idPlanProduction') idPlanProduction: number;

  displayDialog: boolean = false;

  printDetails: boolean = false;

  formatPrinting: string = this.PORTRAIT;

  formatPrintingOptions: any[] = [{ label: 'Paysage', value: this.PAYSAGE }, { label: 'Portrait', value: this.PORTRAIT }];

  ngOnInit(): void {
    this.subDisplayDialog = this.preparationConditionnementSvc.askPrintConditionnement$
      .subscribe(
        () => {
          this.initDates();
        }
      );
    this.typeJourSelected = 'jourCondi';
  }

  ngOnDestroy(): void {
    this.utils.unsubscribe(this.subDisplayDialog)
  }

  closeDialog = (): void => {
    this.displayDialog = false;
    this.formatPrinting = this.PORTRAIT;
    this.printDetails = false;
    this.selectedDates = null;
    this.typeJourSelected = 'jourCondi';
  }

  print = (): void => {
    const bonCondiSettings : BonConditionnementSettingsMl = new BonConditionnementSettingsMl();
    bonCondiSettings.landscape = this.formatPrinting === this.PAYSAGE;
    bonCondiSettings.printDetails = this.printDetails;
    bonCondiSettings.mode = 'SIMPLE';
    this.typeJourSelected === 'jourConso' ? bonCondiSettings.consoDateFilter = this.selectedDates : bonCondiSettings.condiDateFilter = this.selectedDates
    this.preparationConditionnementSvc.printBonConditionnement(this.idPlanProduction, bonCondiSettings);
    this.closeDialog();
  }

  private initDates() {
      this.prodSvc.getPrintSettings(this.idPlanProduction)
        .subscribe(response => {
          if (response) {
            const res: any = response.one;
            this.datesConso = this.convertDates(res.datesConsommation);
            this.datesCondi = this.convertDates(res.datesConditionnement);
          }
        });
    this.displayDialog = true;
  }

  private convertDates(datesToConvert: any) {
    let dateList: any[] = [];
    datesToConvert.sort((n1, n2) => n1 - n2);
    datesToConvert.map((dateConso, idx) => dateList.push({
      id: `${idx}`,
      label: this.utils.getFrenchDate_dddd_Do_MMMM_YYYY(moment(dateConso)),
      value: dateConso
    }));
    return dateList;
  }

  changeJourObligatoire(data: any) {
    this.selectedDates = data.addedItems.map(d => d.value);
  }

  changeSelectedJour(data: any) {
    this.typeJourSelected = data.itemData.value;
  }

}
